import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  screen: {
    minHeight: '100vh',
    padding: '20px 0',
    color: theme.colors.light.ghostWhite,
    fontFamily: theme.fonts.family.primary,
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
  content: {
    padding: '0 20px',
    textAlign: 'center',
  },
  title: {
    fontFamily: 'inherit',
    fontSize: theme.fonts.sizes.titles,
    fontWeight: 100,
  },
  text: {
    marginBottom: 30,
    fontSize: theme.fonts.sizes.heading,
    fontWeight: 100,
  },
  seconds: {
    fontWeight: 300,
    fontSize: theme.fonts.sizes.numberL,
  },
  redirectText: {
    fontSize: theme.fonts.sizes.subTitle,
  },
}));

export const useStylesLinearProgress = makeStyles(theme => ({
  root: {
    height: 10,
    borderRadius: 4,
  },
  colorPrimary: {
    backgroundColor: theme.colors.light.ghostWhite,
  },
  barColorPrimary: {
    backgroundColor: theme.colors.light.freshPoweder,
  },
}));
